<!-- eslint-disable @angular-eslint/template/no-call-expression -->
@if (displayProgressBar()) {
  <onboarding-progress-bar [step]="facade.step$ | async" [totalSteps]="facade.totalSteps" />
}
<onboarding-exit-intent variant="onboarding" />
<div class="container" [zeroLoadingIndicator]="loading()">
  <div class="d-flex align-items-center gap-small">
    <img alt="Logo-Icon" src="/assets/img/svgs/onboarding-logo-part1.svg" />
    <img alt="Logo-Typo" src="/assets/img/svgs/onboarding-logo-part2.svg" />
  </div>
  <div class="content">
    <ng-content />
    <div class="mt-5">
      @if (facade.error$ | async; as error) {
        <div class="zero-text course-red mb-3">{{ error | transloco }}</div>
      } @else if (error()?.message) {
        <div class="zero-text course-red mb-3">{{ error()?.message }}</div>
      }
      <div class="d-flex justify-content-between align-items-center">
        <div>
          @if (!hideBack()) {
            <div class="back-circle" (click)="back.emit()">
              <web-design-system-icon name="chevron-3" />
            </div>
          }
        </div>
        <div class="d-flex justify-content-end align-items-center gap">
          @if (!hideForward()) {
            @if (specialAction()) {
              <div class="d-none d-md-block">
                <ng-container *ngTemplateOutlet="specialActionTemplate" />
              </div>
            }
            <web-design-system-button data-zid="next" [disabled]="!formValid()" [fullwidth]="true" (click)="forward.emit()">
              {{ buttonLabel() ?? 'onboarding.next' | transloco }}
            </web-design-system-button>
          }
        </div>
      </div>
      @if (specialAction()) {
        <div class="d-flex justify-content-center mt-3 d-md-none">
          <div class="d-block d-md-none">
            <ng-container *ngTemplateOutlet="specialActionTemplate" />
          </div>
        </div>
      }
    </div>
  </div>
</div>
<onboarding-footer [hideLogout]="hideLogout()" />

<ng-template #specialActionTemplate>
  <a class="zero-text" [ngClass]="specialActionColor()" (click)="specialActionClicked.emit()">{{ specialAction() }}</a>
</ng-template>
